(function () {
  function initStickyBar() {
    var stickyBar = document.querySelector('[data-dorimo-sticky-atc]');
    var target = document.querySelector('.product-form__buttons');
    if (!stickyBar || !target || stickyBar.dataset.ready) return;
    stickyBar.dataset.ready = 'true';

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var hasPassedBuyButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', hasPassedBuyButton);
        });
      },
      { rootMargin: '0px 0px -40% 0px' }
    );

    observer.observe(target);
  }

  function initFallbackGalleries() {
    document.querySelectorAll('[data-dorimo-fallback-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';

      // Slaytlar yatay scroll-snap seridinde durur; konumu serit kaydikca okuruz,
      // boylece parmakla kaydirma, oklar ve kucuk onizlemeler ayni durumu paylasir.
      var track = gallery.querySelector('[data-dorimo-gallery-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      var current = gallery.querySelector('[data-dorimo-gallery-current]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-dorimo-gallery-thumb]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-dorimo-gallery-dot]'));
      if (slides.length < 2) return;

      var index = 0;

      function paint(nextIndex) {
        index = nextIndex;
        if (current) current.textContent = String(nextIndex + 1);

        thumbs.forEach(function (thumb, thumbIndex) {
          var isActive = thumbIndex === nextIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', String(isActive));
        });

        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', String(isActive));
        });

        if (thumbs[nextIndex]) {
          thumbs[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      function goTo(nextIndex) {
        var clamped = Math.max(0, Math.min(slides.length - 1, nextIndex));
        track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
      }

      var frame;
      track.addEventListener(
        'scroll',
        function () {
          window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(function () {
            if (!track.clientWidth) return;
            var nextIndex = Math.round(track.scrollLeft / track.clientWidth);
            nextIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));
            if (nextIndex !== index) paint(nextIndex);
          });
        },
        { passive: true }
      );

      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-dorimo-gallery-thumb]');
        if (thumb && gallery.contains(thumb)) {
          goTo(thumbs.indexOf(thumb));
          return;
        }

        var dot = event.target.closest('[data-dorimo-gallery-dot]');
        if (dot && gallery.contains(dot)) {
          goTo(dots.indexOf(dot));
          return;
        }

        var arrow = event.target.closest('[data-dorimo-gallery-direction]');
        if (arrow && gallery.contains(arrow)) {
          goTo(index + (arrow.dataset.dorimoGalleryDirection === 'next' ? 1 : -1));
        }
      });

      paint(0);
    });
  }

  function localizePaymentButtons() {
    document.querySelectorAll('.dorimo-product-main .shopify-payment-button__button--unbranded').forEach(function (button) {
      if (button.textContent.trim() !== 'Hemen satın al') {
        button.textContent = 'Hemen satın al';
      }
      button.setAttribute('aria-label', 'Hemen satın al');
    });
  }

  function observePaymentButtons() {
    var root = document.querySelector('.dorimo-product-main');
    if (!root || root.dataset.paymentButtonObserverReady) return;
    root.dataset.paymentButtonObserverReady = 'true';

    localizePaymentButtons();
    var observer = new MutationObserver(localizePaymentButtons);
    observer.observe(root, { childList: true, subtree: true });
  }

  // Gorselin sag altindaki "Urun Videosunu Izle" butonu: videoyu <dialog>
  // icinde acar, kapaninca durdurup basa sarar (arka planda ses calmasin).
  function initProductVideo() {
    document.querySelectorAll('[data-dorimo-video-modal]').forEach(function (modal) {
      if (modal.dataset.ready) return;
      modal.dataset.ready = 'true';

      var scope = modal.parentElement || document;
      var opener = scope.querySelector('[data-dorimo-video-open]');
      var closer = modal.querySelector('[data-dorimo-video-close]');
      var player = modal.querySelector('[data-dorimo-video-player]');
      if (!opener || !player) return;

      opener.addEventListener('click', function () {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
        var played = player.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});
      });

      var close = function () {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      };

      if (closer) closer.addEventListener('click', close);

      // Videonun disina (koyu zemine) tiklayinca da kapansin.
      modal.addEventListener('click', function (event) {
        if (event.target === modal) close();
      });

      modal.addEventListener('close', function () {
        player.pause();
        player.currentTime = 0;
      });
    });
  }

  function init() {
    initStickyBar();
    initFallbackGalleries();
    initProductVideo();
    observePaymentButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
